import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { ModalClose } from './ModalClose';
import endpoints from '../../define/endpoints';
import { selector_auth } from '../../reducer/auth';
import { useListingCancellation } from '../../hooks/useListingCancellation';
import { FullPageLoaderContainer } from '../common';
import { formatCurrency } from '../../utils/format';

import { Modal } from './Modal';
import Tooltip from '../Tooltip';

const ModalOrderListDeleteBooking = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const auth = useSelector(selector_auth);
  const [labelCancellation, tooltipCancellation] = useListingCancellation(
    props.order && props.order.listing && props.order.listing.cancellation
  );
  if (!props.order) {
    return null;
  }
  return (
    <>
      <FullPageLoaderContainer isOpen={isLoading} />
      <Modal
        isOpen={props.isOpen}
        onClickOverlay={() => props.setIsOpen(false)}
        shouldScroll={props.shouldScroll}
      >
        <div className={cn('modal-ord-li-delete-booking')}>
          <ModalClose onClick={() => props.setIsOpen(false)} />
          <h4 className={cn('modal-ord-li-delete-booking__title')}>
            {app_main_wpml.refund_policy}
          </h4>
          <p className={cn('modal-ord-li-delete-booking__subtitle')}>
            {app_main_wpml.refund_alert}
          </p>
          <div className={cn('modal-ord-li-delete-booking__keys-values')}>
            <div className={cn('key-value')}>
              <p className={cn('key-value__key')}>
                {' '}
                {app_main_wpml.refund_policy}
              </p>
              <p className={cn('key-value__value')}>
                <Tooltip text={tooltipCancellation} withMarginRight={true} />
                {labelCancellation}
              </p>
            </div>
            <div className={cn('key-value')}>
              <p className={cn('key-value__key')}>
                {app_main_wpml.refund_total}
              </p>
              <p className={cn('key-value__value')}>
                {formatCurrency(props.order.totalRefundable)}
              </p>
            </div>
          </div>
          <p className={cn('modal-ord-li-delete-booking__text')}>
            {app_main_wpml.refund_instructions}
          </p>
          <div className={cn('modal-ord-li-delete-booking__buttons')}>
            <button
              className={cn(
                'modal-ord-li-delete-booking__buttons__btn',
                'btn',
                'btn--light',
                'btn--short'
              )}
              onClick={() => props.setIsOpen(false)}
            >
              {app_main_wpml.cancel}
            </button>
            <button
              className={cn(
                'modal-ord-li-delete-booking__buttons__btn',
                'btn',
                'btn--short'
              )}
              onClick={async () => {
                setIsLoading(true);
                await axios({
                  method: 'post',
                  url: `${endpoints.core}/orders/${props.order.id}/cancel`,
                  headers: {
                    Authorization: `Bearer ${auth.token}`,
                  },
                });
                setIsLoading(false);
                props.onFinish();
              }}
            >
              {app_main_wpml.delete_booking}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

ModalOrderListDeleteBooking.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  order: PropTypes.object,
  shouldScroll: PropTypes.bool.isRequired,
  onFinish: PropTypes.func.isRequired,
};

export { ModalOrderListDeleteBooking };
